import moment from "moment";
import * as React from "react";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/Save";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonGroup from "@mui/material/ButtonGroup";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import {
	emptyOrder,
	ordersTableColumns,
	orderStatusTranslationConformity,
	deliveryTypeTranslationConformity,
} from "./common";
import OrdersRowHistory from "./OrdersRowHistory";
import CommonDialog from "../common-dialogs/DeleteDialog";

export default function OrdersEditableRow({ row, actions }) {
	const [openHistory, setOpenHistory] = React.useState(false);
	const [openConfirmOrderNumberChange, setOpenConfirmOrderNumberChange] =
		React.useState(false);
	const isEmptyOrder = row.id === emptyOrder.id;

	const [orderNumber, setOrderNumber] = React.useState(row.orderNumber);
	const [clientName, setClientName] = React.useState(
		row.clientName ? row.clientName : ""
	);
	const [employee1c, setEmployee1c] = React.useState(row.employee1c);
	const [storage, setStorage] = React.useState(row.storage);
	const [archived, setArchived] = React.useState(row.archived);
	const [status, setStatus] = React.useState(row.status);
	const [deliveryType, setDeliveryType] = React.useState(row.deliveryType);
	const [deliveryAddress, setDeliveryAddress] = React.useState(
		row.deliveryAddress ? row.deliveryAddress : ""
	);
	const [createdAt, setCreatedAt] = React.useState(row.date);

	const saveRow = () =>
		actions.saveRow({
			id: row.id,
			orderNumber,
			clientName,
			status,
			archived,
			storage,
			employee1c,
			deliveryType,
			deliveryAddress,
			date: createdAt,
		});
	const handleSaveRowClick = async () => {
		if (orderNumber !== row.orderNumber && !isEmptyOrder) {
			setOpenConfirmOrderNumberChange(() => true);
		} else {
			saveRow();
		}
	};

	const handleCancelEditRowClick = () => {
		actions.cancelEdit(row.id);
	};

	const handleDeleteRowClick = () => {
		actions.tryDeleteRow(row.id);
	};

	const textInput = ({
		value,
		setValue,
		disabled = false,
		width = "16ch",
		focusWidth = "22ch",
	}) => (
		<TextField
			inputRef={(input) => input}
			sx={{
				width: width,
				"& .Mui-focused": {
					width: focusWidth,
					background: "white",
					zIndex: 1,
				},
				"& .MuiInputBase-input": {
					width: "100%",
					height: 0,
				},
			}}
			variant="outlined"
			onChange={(event) => setValue(event.target.value)}
			value={value}
			disabled={disabled}
			inputProps={{ "aria-label": "value" }}
		/>
	);
	return (
		<React.Fragment>
			<TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
				{ordersTableColumns.map((column) => (
					<TableCell
						key={column.id}
						align={column.align}
						minWidth={column.minWidth}
					>
						{column.id === "buttons" && (
							<div>
								<div style={{ display: "flex", gap: 15 }}>
									<ButtonGroup
										variant="outlined"
										aria-label="outlined button group"
									>
										<Button
											onClick={() => handleSaveRowClick()}
											disabled={
												!clientName ||
												!orderNumber ||
												!employee1c ||
												!storage ||
												!status ||
												!deliveryType
											}
										>
											<SaveIcon />
										</Button>
										<Button
											color="error"
											onClick={() => handleDeleteRowClick()}
											disabled={isEmptyOrder}
										>
											<DeleteIcon />
										</Button>
										<Button
											color="error"
											onClick={() => handleCancelEditRowClick()}
										>
											<CloseIcon />
										</Button>
									</ButtonGroup>
								</div>
							</div>
						)}
						{column.id === "collapseButton" && (
							<IconButton
								aria-label="expand row"
								size="small"
								onClick={() => setOpenHistory(!openHistory)}
							>
								{openHistory ? (
									<KeyboardArrowUpIcon />
								) : (
									<KeyboardArrowDownIcon />
								)}
							</IconButton>
						)}
						{column.id === "managerUser" && row.managerUser?.name}
						{column.id === "driver" && row.driver?.name}
						{column.id === "orderNumber" &&
							textInput({
								value: orderNumber,
								setValue: setOrderNumber,
								width: 105,
								focusWidth: 115,
							})}
						{column.id === "clientName" &&
							textInput({
								value: clientName,
								setValue: setClientName,
								width: 240,
								focusWidth: 250,
							})}
						{column.id === "status" && (
							<FormControl sx={{ m: 1, minWidth: 120 }} size="small">
								<InputLabel>Статус</InputLabel>
								<Select
									label="Статус"
									value={status}
									onChange={(event) => {
										setStatus(event.target.value);
									}}
								>
									{Object.keys(orderStatusTranslationConformity).map((s) => (
										<MenuItem key={s} value={s}>
											{orderStatusTranslationConformity[s]}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						)}
						{column.id === "archived" && !isEmptyOrder && (
							<Checkbox
								checked={archived}
								onChange={(event) => {
									setArchived((oldState) => !oldState);
								}}
							/>
						)}
						{column.id === "employee1c" &&
							textInput({
								value: employee1c,
								setValue: setEmployee1c,
								width: 45,
								focusWidth: 45,
							})}
						{column.id === "storage" &&
							textInput({ value: storage, setValue: setStorage })}
						{column.id === "warehouse" &&
							(row.warehouse ? `${row.warehouse.city}` : "")}
						{column.id === "deliveryType" && (
							<FormControl sx={{ m: 1, minWidth: 120 }} size="small">
								<InputLabel>Тип доставки</InputLabel>
								<Select
									label="Тип доставки"
									value={deliveryType}
									onChange={(event) => setDeliveryType(event.target.value)}
								>
									{Object.keys(deliveryTypeTranslationConformity).map((s) => (
										<MenuItem key={s} value={s}>
											{deliveryTypeTranslationConformity[s]}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						)}
						{column.id === "deliveryAddress" &&
							textInput({
								value: deliveryAddress,
								setValue: setDeliveryAddress,
							})}
						{column.id === "createdAt" &&
							moment(row.date).format("DD MMM YYYY HH:mm")}
					</TableCell>
				))}
			</TableRow>
			{!isEmptyOrder && (
				<OrdersRowHistory
					open={openHistory}
					orderHandleTacts={row.orderHandleTacts}
				/>
			)}
			<CommonDialog
				open={openConfirmOrderNumberChange}
				confirmAction={saveRow}
				cancelAction={() => setOpenConfirmOrderNumberChange(() => false)}
				question={`Ви хочете змінити номер накладної з ${row.orderNumber} на ${orderNumber}?`}
			/>
		</React.Fragment>
	);
}
